// Module
var code = `<survey-modal platforms="vm.platforms" survey-manager="vm.surveyManager" is-consent="vm.isConsent" ng-if="vm.template"></survey-modal> `;
// Exports
export default code;